import React from 'react';
import { Route, IndexRoute } from 'react-router';

import AttendeRefundRequestPage from './pages/AttendeeRefundRequestPage';
import ConnectedPage from './containers/ConnectedPage';
import { BASE_URL } from './constants';

const getRoutes = (appProps) => {
    const PageWithAppProps = (props) => (
        <ConnectedPage {...appProps} {...props} />
    );
    return (
        <Route path={BASE_URL} component={PageWithAppProps}>
            <IndexRoute component={AttendeRefundRequestPage} />
        </Route>
    );
};

export default getRoutes;
